import React, { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import {
  Box,
  Stack,
  SvgIcon,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ReactComponent as Back } from 'assets/images/ic_back.svg';
import { ReactComponent as Template } from 'assets/images/ic_template.svg';
import { ReactComponent as Build } from 'assets/images/ic_build.svg';
import { ReactComponent as LinkExternal } from 'assets/images/ic_link_external.svg';
import { useNavigate } from 'react-router-dom';
import PageHeader from 'shared/components/PageHeader';
import { AppPrimaryButton } from 'shared/components/AppComponents';

const AddNewTraining = (): ReactElement => {
  const theme = useTheme();
  const navigation = useNavigate();
  const match = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <PageHeader
        title="Add New Training Program"
        description="First, select from the options how you'd like to create your training."
        actions={
          <AppPrimaryButton
            className="btn-small"
            onClick={() => navigation('/training-programs')}
            startIcon={
              <SvgIcon
                component={Back}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
              />
            }
            title="Return Training Management"
          />
        }
      />
      <Box className="training training-programs">
        <HeadTag title="Select Training Template" />
        <Box className="training-programs add-new">
          <Stack spacing={4} direction="column">
            <Box className="training-heading">
              <Typography variant="h4">Select Training Template</Typography>
              <Typography component="span" variant="body1">
                Choose from the following that best fits your training needs.
              </Typography>
            </Box>
            <Stack direction={match ? 'column' : 'row'} spacing={2}>
              <Box
                className="selection-training"
                component="button"
                onClick={() => {
                  navigation('/training-programs/training-template');
                }}
              >
                <Stack direction="row" spacing={1}>
                  <SvgIcon
                    component={Template}
                    inheritViewBox
                    className="view-icon"
                    fontSize="inherit"
                    htmlColor="#3D3C42"
                  />
                  <Typography variant="h6">
                    Ready-to-use Training Template
                  </Typography>
                </Stack>
                <Typography variant="body2" component="span">
                  Start with a ready-to-use template designed for specific roles
                  and responsibilities.
                </Typography>
              </Box>
              <Box
                className="selection-training"
                component="button"
                onClick={() => {
                  navigation('/training-programs/add');
                }}
              >
                <Stack direction="row" spacing={1}>
                  <SvgIcon
                    component={Build}
                    inheritViewBox
                    className="view-icon"
                    fontSize="inherit"
                    htmlColor="#3D3C42"
                  />
                  <Typography variant="h6">
                    Build a custom training template
                  </Typography>
                </Stack>
                <Typography variant="body2" component="span">
                  Start from a blank template and design your custom training
                  program.
                </Typography>
              </Box>
              <Box
                className="selection-training"
                component="button"
                onClick={() => {
                  navigation(
                    '/training-programs/add-external-training-programs'
                  );
                }}
              >
                <Stack direction="row" spacing={1}>
                  <SvgIcon
                    component={LinkExternal}
                    inheritViewBox
                    className="view-icon"
                    fontSize="inherit"
                    htmlColor="#3D3C42"
                  />
                  <Typography variant="h6">
                    Link to External Training Course
                  </Typography>
                </Stack>
                <Typography variant="body2" component="span">
                  Reference external training courses or resources via URL.
                </Typography>
              </Box>
            </Stack>
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default AddNewTraining;
